import { Component, OnInit, Input, ViewChild, Output } from '@angular/core';
import { StoreService } from '../../../_services';
import { IChangeCallback, IStore } from '../../../_entities';
import { PopoverInput } from '../base/popover-input';
import { List } from 'linqts';

import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';

import * as _ from 'lodash';

@Component({
	selector: 'multiple-own-region-store-tree',
	template: require('./multiple-own-region-store-tree.component.html')
})
export class MultipleOwnRegionStoreTreeComponent extends PopoverInput implements OnInit {

	constructor(private storeService: StoreService) {
		super();
		this.stores = this.storeService.getRegionStoreList();
		this.config = TreeviewConfig.create({
			hasAllCheckBox: false,
			hasFilter: true,
			hasCollapseExpand: false,
			decoupleChildFromParent: false,
			maxHeight: 260
		});

	}

	
	stores: Promise<any[]>;

	config: TreeviewConfig;

	items: TreeviewItem[];

	ngOnInit() {
		this.init();
	}

	anyChecked(item) {
		return item.children.findIndex(x => x.checked) > -1;
	}

	//event innehåller hela arrayen av valda regioner
	onSelectedChange($event: any) {
		if (!!$event && Array.isArray($event)) {
			this.dirtyValue = $event.filter(storeId => storeId> 0);
		}
	}

	public init(): void {
		this.stores.then(result => {
			var x = result.map(country => ({
				text: country.name,
				collapsed: !country.regions.some(region => region.stores.some(store => (this.originalValue.indexOf(store.id) > -1))),
				value: 0,
				children: country.regions.map(region => ({
					text: region.name,
					collapsed: !region.stores.some(store => this.originalValue.indexOf(store.id) > -1),
					value: 0,
					children: region.stores.map(store => ({
						value: store.id, text: store.storeCode + " · " + store.popularName, checked: this.originalValue.indexOf(store.id) > -1})) || []

				})) || []
			})) || [];

			var treeItems = x.map(x => new TreeviewItem(x)) || [];

			this.items = treeItems;

		});
	}

	public onShow(): void {
		this.init();
	}

	get hasChanges() {
		if (!this.dirtyValue)
			return false;

		const arraysSame = (this.dirtyValue.length === this.originalValue.length) &&
			(this.dirtyValue.length === _.intersection(this.dirtyValue, this.originalValue).length);

		var hasChanges = !arraysSame;

		return hasChanges;
	}

	get selectedCountries(): TreeviewItem[] {

		if (!!this.items && this.originalValue) {
			return this.items.filter(x => 
				(x.children || []).some(y => (y.children || []).some(z =>  this.originalValue.indexOf(z.value) > -1)));
		}

		return null;
	}

	getSelectedStores(item: TreeviewItem): TreeviewItem[] {

		const list = new List(item.children);

		return list.SelectMany(x => new List(x.children).Where(x => this.originalValue.indexOf(x.value) > -1)).ToArray();

	}

	getSelectedStoresList(item: TreeviewItem): string {
		return this.getSelectedStores(item).map(x => x.text).join(", ");
	}
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/multiple-own-region-store-tree.component.ts